export default __webpack_public_path__ + "28c045bebb857aa5e14fc727cb22e237.png";